<template>
  <div>
    <div class="mb-10">
      <div class="display-1 font-weight-light">
        <span class="pl-5">Reference</span>
        <v-divider></v-divider>
      </div>

      <p class="pa-5 pb-0 font-italic font-weight-light">
        Tato část je věnována referencím, respektive popisu projektů, na kterých jsem se podílel
        v posledních letech. Cílem není popsat absolutně všechny projekty, spíše ty zajímavější,
        u kterých jsou použity různé druhy technologií.
      </p>

      <SvetBot></SvetBot>
      <SkinCulture></SkinCulture>
      <Asw></Asw>
      <Kds></Kds>
      <Webcare></Webcare>
      <AdminConsole></AdminConsole>
      <Infomap></Infomap>
      <SpectuConnector></SpectuConnector>
      <Pcs></Pcs>
    </div>

  </div>
</template>

<script>
  import AdminConsole from "./refs/AdminConsole";
  import Asw from "./refs/Asw";
  import Infomap from "./refs/Infomap";
  import Kds from "./refs/Kds";
  import Pcs from "./refs/Pcs";
  import SkinCulture from "./refs/SkinCulture";
  import SpectuConnector from "./refs/SpectuConnector";
  import SvetBot from "./refs/SvetBot";
  import Webcare from "./refs/Webcare";

  import ImgGallery from "@/components/ImgGallery";

  export default {
    name: "References",
    components: {
      AdminConsole,
      Asw,
      ImgGallery,
      Infomap,
      Kds,
      Pcs,
      SkinCulture,
      SpectuConnector,
      SvetBot,
      Webcare,
    }
  }
</script>

<style scoped>

</style>
